import React, { Component } from 'react';
import Article from './article';
import { MEDIA_TYPE_IS_CALLBACK } from '../../../app-constants';
import RequestCallbackModal from './request-callback-modal';

class RequestCallbackView extends Component {
  constructor(props) {
    super(props);

    const {
      callbackRequested = false,
    } = this.props;

    this.state = {
      callbackRequestComplete: callbackRequested,
    };
  }

  openModal = () => {
    const {
      actions: {
        openCallbackRequestModal,
      },
    } = this.props;
    openCallbackRequestModal();
  };

  closeModal = () => {
    const {
      actions: {
        closeCallbackRequestModal,
      },
    } = this.props;
    closeCallbackRequestModal();
  };

  requestCallback = () => {
    const {
      callbackRequest,
    } = this.props;

    callbackRequest();

    this.setState({ callbackRequestComplete: true });
  };

  render() {
    const {
      callbackRequestComplete,
    } = this.state;

    const {
      title,
      summary,
      imageUrl,
      imageAltText,
      buttonText,
      customContent: {
        requestCallBack: {
          postRequestCallBack: {
            title: postRequestTitle,
            summary: postRequestSummary,
            imageUrl: postRequestImage,
            imageAltText: postRequestImgAltText,
          },
          requestCallBackModal,
          thankYouModal,
        },
      },
      callbackRequestModalIsOpen,
    } = this.props;

    const preRequestCallbackContent = {
      title,
      summary,
      imageUrl,
      imageAltText,
      buttonText,
      clickAction: this.openModal,
      mediaType: MEDIA_TYPE_IS_CALLBACK,
    };

    const postRequestCallbackContent = {
      title: postRequestTitle || title,
      summary: postRequestSummary || summary,
      imageUrl: postRequestImage || imageUrl,
      imageAltText: postRequestImgAltText || imageAltText,
    };

    return (
      <React.Fragment>
        <RequestCallbackModal
          closeModal={this.closeModal}
          requestCallback={this.requestCallback}
          modalIsOpen={callbackRequestModalIsOpen}
          callbackRequestComplete={callbackRequestComplete}
          requestCallBackModal={requestCallBackModal}
          thankYouModal={thankYouModal}
        />
        {callbackRequestComplete
          ? <Article {...postRequestCallbackContent} />
          : <Article {...preRequestCallbackContent} />
        }
      </React.Fragment>
    );
  }
}

export default RequestCallbackView;
